import { useAuth } from '../context/AuthContext';
import LoginPrompt from './LoginPrompt';

function RequireAuth({ children }) {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        return <LoginPrompt />;
    }

    return children;
}

export default RequireAuth;
